

























































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import MachineRentSearch from '@/app/components/MachineRent/MachineRentSearch.vue'
import MachineRentListHeader from '@/app/components/MachineRent/MachineRentListHeader.vue'
import MachineRentList from '@/app/components/MachineRent/MachineRentList.vue'
import Pagination from '@/app/components/Common/Pagination.vue'
/* api */
import MachineRentListApi from '@/app/model/api/machineRentListApi'
/* module */
import DateClass from '@/app/module/date'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    MachineRentSearch,
    MachineRentListHeader,
    MachineRentList,
    Pagination
  }
})
export default class machineRent extends Vue {
  private totalCount: number = 0
  private notDataMessage: boolean = false
  private showLoading: boolean = true
  private machineRentData: any = {}
  private isRequesting: boolean = true
  private currentPage: number = 1
  private isCloseToggle: boolean = false

  created () {
    this.getMachineRentList()
  }

  private toggle (flag: boolean) {
    this.isCloseToggle = false
    const allToggles = document.getElementsByClassName('toggle')
    for (let i = 0; i < allToggles.length; i++) {
      let $el: HTMLElement = allToggles[i] as HTMLElement
      const parentElement: any = $el.parentElement
      if (flag) {
        // 開く
        if (parentElement.getAttribute('aria-expanded') === 'false') {
          $el.click()
        }
      } else {
        // 閉じる
        if (parentElement.getAttribute('aria-expanded') !== 'false') {
          $el.click()
        }
      }
    }
  }

  private closeToggle () {
    const allToggles = document.getElementsByClassName('toggle')
    for (let i = 0; i < allToggles.length; i++) {
      let $el: HTMLElement = allToggles[i] as HTMLElement
      const parentElement: any = $el.parentElement
      // 閉じる
      if (parentElement.getAttribute('aria-expanded') !== 'false') {
        $el.click()
        this.isCloseToggle = true
      }
    }
  }

  private getMachineRentList () {
    (async () => {
      const data = {
        word: this.$store.state.machineRentState.searchText,
        order_name: this.$store.state.machineRentState.orderName,
        sort: this.$store.state.machineRentState.sortAsc,
        step: this.$store.state.machineRentState.step,
        rent_status: this.$store.state.machineRentState.rentStatus,
        group_id: this.$store.state.machineRentState.groupId,
        machine_id: this.$store.state.machineRentState.machineId,
        machine_type: this.$store.state.machineRentState.machineType,
        created_at: DateClass.dateToStringYmd(this.$store.state.machineRentState.createdAt, '-'),
        created_by: this.$store.state.machineRentState.createdBy,
        created_type: this.$store.state.machineRentState.createdType,
        rent_start_date: DateClass.dateToStringYmd(this.$store.state.machineRentState.rentStartDate, '-'),
        rent_end_date: DateClass.dateToStringYmd(this.$store.state.machineRentState.rentEndDate, '-'),
        use_start_date: DateClass.dateToStringYmd(this.$store.state.machineRentState.useStartDate, '-'),
        use_end_date: DateClass.dateToStringYmd(this.$store.state.machineRentState.useEndDate, '-'),
        limit: this.$store.state.machineRentState.limit,
        page: this.$store.state.machineRentState.page,
        role_no: this.$store.state.machineRentState.accountId
      }

      const result = await MachineRentListApi.getMachineRentList(data)

      if (result.isOk()) {
        this.machineRentData = result.getPayload().results
        this.totalCount = result.getPayload().total_count
        this.currentPage = this.$store.state.machineRentState.page

        if (this.totalCount === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
      this.isRequesting = false
    })()
  }

  private doMachineSort (data: string) {
    this.isRequesting = true
    this.showLoading = true
    this.scrollTop()
    this.closeToggle()

    let sort = false
    if (data === this.$store.state.machineRentState.orderName) {
      if (this.$store.state.machineRentState.sortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('machineRentState/setOrderName', data)
    this.$store.commit('machineRentState/setSortAsc', sort)
    this.$store.commit('machineRentState/setCurrentPage', 1)
    this.getMachineRentList()
  }

  private changeList () {
    this.isRequesting = true
    this.showLoading = true
    this.$store.commit('machineRentState/setOrderName', 'created_at')
    this.$store.commit('machineRentState/setSortAsc', false)
    this.$store.commit('machineRentState/setCurrentPage', 1)
    this.scrollTop()
    this.getMachineRentList()
    this.closeToggle()
  }

  private scrollTop () : any {
    const listArea: any = document.getElementById('listContainer')!
    listArea.scrollTop = 0
  }

  private onPageChange (page: number) {
    if (!this.isRequesting) {
      this.currentPage = page
      this.showLoading = true
      this.scrollTop()
      this.$store.commit('machineRentState/setCurrentPage', page)
      this.getMachineRentList()
      this.closeToggle()
    }
  }
}
